import Component from './ColumnChooserHeader.component';

export default Component;
